import get from 'lodash/get';
import {
  USER_INFO_REQUEST,
  USER_INFO_SUCCESS,
  USER_INFO_FAILURE,
  USER_INFO_UPDATE,

  CUSTOMER_INFO_REQUEST,
  CUSTOMER_INFO_SUCCESS,
  CUSTOMER_INFO_FAILURE,
  CUSTOMER_INFO_UPDATE
} from './action-constants';

const initialState = {
  userInfo: null,
  userInfoloading: true,
  customerInfo: null,
  customerInfoLoading: true
};

export const authReducerKey = 'auth';
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_INFO_REQUEST:
      return {
        ...state,
        userInfoloading: true
      };
    case USER_INFO_SUCCESS:
      const userInfo = action.payload;
      return {
        ...state,
        userInfo,
        userInfoloading: false
      };
    case USER_INFO_FAILURE:
      return {
        ...state,
        userInfoloading: false
      };
    case USER_INFO_UPDATE:
      const updatedUserInfo = action.payload;
      return {
        ...state,
        userInfo: {
          ...get(state, 'userInfo', {}),
          ...updatedUserInfo
        }
      };
    case CUSTOMER_INFO_REQUEST:
      return {
        ...state,
        customerInfoLoading: true
      };
    case CUSTOMER_INFO_SUCCESS:
      const customerInfo = action.payload;
      return {
        ...state,
        customerInfo,
        customerInfoloading: false
      };
    case CUSTOMER_INFO_FAILURE:
      return {
        ...state,
        customerInfoloading: false
      };
    case CUSTOMER_INFO_UPDATE:
      const udpatedCustomerInfo = action.payload;
      return {
        ...state,
        customerInfo: {
          ...get(state, 'customerInfo', {}),
          ...udpatedCustomerInfo
        }
      };
    default:
      return state;
  }
};
